import axios from "axios";

const CryptoJS = require("crypto-js");

axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
axios.interceptors.request.use(function (config) {
    if (process.env.NODE_ENV !== 'production') {
        console.debug("AXIOS Request " + JSON.stringify(config));
    }

    config.withCredentials = true
    config.headers['x-secret'] = undefined

    let data
    if (config.data) {
        data = config.data
    } else if (config.params) {
        data = config.params
    }

    if (data) {
        config.headers['x-secret'] = ''
        const keys = Object.keys(data).map(key => {
            return key
        })
        const sortedKeys = keys.sort()
        sortedKeys.forEach(key => {
            let valueReachingWebBack = data[key] !== undefined
            if (valueReachingWebBack) {
                if (data[key] === null) {
                    const queryIsNotGetReq = config.method !== 'get'
                    if (queryIsNotGetReq) {
                        config.headers['x-secret'] += null
                    }
                } else {
                    config.headers['x-secret'] += data[key].toString()
                }
            }
        })
        config.headers['x-secret'] = CryptoJS.SHA512(config.headers['x-secret']).toString()
    }

    config.withCredentials = true
    config.timeout = 0
    return config
}, function (error) {
    console.error("AXIOS Request Error " + JSON.stringify(error));
    return Promise.reject(error);
});

export const makeRequest = (url, method, params, headers, reducer, responseType) => {
    switch (method) {
        case "POST" : {
            return {
                type: reducer,
                payload: axios.post(url, params,
                    {
                        headers: headers
                    })
            }
        }
        case "PUT" : {
            return {
                type: reducer,
                payload: axios.put(url, params,
                    {
                        headers: headers,
                    })
            }
        }
        case "GET" : {
            return {
                type: reducer,
                payload: axios.get(url, {
                    headers: headers,
                    params: params,
                    responseType: responseType ? responseType : 'json'
                })
            }
        }
        case "DELETE" : {
            return {
                type: reducer,
                payload: axios.delete(url, {
                    headers: headers,
                    data: params
                })
            }
        }
        default:
            break;
    }
};